import template from './swag-migration-profile-shopware-api-page-information.html.twig';

const { Component } = Shopware;

/**
 * @package services-settings
 */
Component.register('swag-migration-profile-shopware-api-page-information', {
    template,
});
